import { Tooltip } from '@lib/components'
import { Badge } from '@octopus-do/octopus-storybook'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import { selectAIRemainingRequests } from '@store/reducers/ai/selectors'
import clsJoin from 'classnames'
import { useSelector } from 'react-redux'

import { useOpenUpgradeModal } from '../../hooks'
import css from './styles.module.css'

const RemainingRequestsText = ({ remaining }: { remaining: number | null }) => {
  const handleOnUpgradeClick = useOpenUpgradeModal()

  if (remaining === null) {
    return null
  }

  if (remaining === 0) {
    return (
      <div className={clsJoin(css.info_remaining, css.reached)}>
        Actions limit reached.
        <div
          className={css.remaining_reached_button}
          onClick={handleOnUpgradeClick}
        >
          Upgrade
          <AngleRight className={css.icon} />
        </div>
      </div>
    )
  }

  const label = remaining === 1 ? 'action' : 'actions'
  return (
    <div className={css.info_remaining}>
      {remaining} {label} remaining
    </div>
  )
}

export const RemainingLimits = () => {
  const remainingRequests = useSelector(selectAIRemainingRequests)

  return (
    <div className={css.info}>
      <div className={css.info_remaining}>
        <RemainingRequestsText remaining={remainingRequests} />
      </div>
      <div>
        <Tooltip
          position="top"
          content={
            <div>
              AI assistant is running in <br />
              testing mode, so the number
              <br /> of prompts is limited
            </div>
          }
          autoWidth
        >
          <a
            href="https://help.octopus.do/article/192-sitemap-ai-assistant-beta-version"
            target="_blank"
            rel="noopener"
          >
            <Badge type="beta" />
          </a>
        </Tooltip>
      </div>
    </div>
  )
}
